<template>
  <!-- 导航栏 -->
  <!-- <nav class="navbar">
    <h1>城市缘分签</h1>
  </nav> -->

  <!-- 主页面 -->
  <div class="main-page" id="mainPage">
    <!-- 标题区 -->
    <div class="title-container">
      <div class="title-container">
        <h1 data-text="CYBER DESTINY">CYBER DESTINY</h1>
        <h2>// FIND YOUR DIGITAL FATE //</h2>
      </div>
      <h2>哪个城市与你最有缘？</h2>
    </div>
    
    <div class="word-cloud-container">
      <ThreeDWordCloud 
        ref="wordCloud"
        :cities="displayCities" 
        @city-selected="showResult" 
      />
    </div>
    <button 
      class="lottery-button" 
      @click="randomCity"
      :disabled="isDrawing"
    >
      {{ isDrawing ? '抽签中...' : '开始抽签' }}
    </button>
  </div>

  <!-- 结果弹窗 -->
  <ResultModal 
    v-if="showModal" 
    :city="selectedCity"
    :cityInfo="cityInfo"
    @close="closeModal"
    @view-guide="viewGuide"
  />

  <!-- 攻略页面 -->
  <GuidePage 
    v-if="showGuide" 
    :city="selectedCity"
    :cityData="cityData"
    @back="backToHome"
    @continue="continueDrawing"
  />
</template>

<script>
import ThreeDWordCloud from './3DWordCloud.vue'
import ResultModal from './ResultModal.vue'
import GuidePage from './GuidePage.vue'

export default {
  name: 'HomePage',
  components: {
    ThreeDWordCloud,
    ResultModal,
    GuidePage
  },
  data() {
    return {
      allCitiesList: [], // 存储所有城市列表
      displayCities: [], // 显示在词云中的城市（最多100个）
      allCities: {},
      selectedCity: null,
      cityInfo: null,
      cityData: null,
      showModal: false,
      showGuide: false,
      isDrawing: false
    }
  },
  created() {
    this.loadCities()
  },
  methods: {
    async loadCities() {
      try {
        const response = await fetch('/cities.json')
        const data = await response.json()
        console.log('原始响应数据:', data)
        
        if (!data || typeof data !== 'object') {
          throw new Error('城市数据格式不正确：数据为空或不是对象')
        }
        
        const provinces = Object.keys(data)
        if (provinces.length === 0) {
          throw new Error('城市数据格式不正确：没有找到省份数据')
        }
        
        this.allCities = data
        
        // 提取所有城市名称
        let cityList = []
        for (const province in this.allCities) {
          if (Array.isArray(this.allCities[province])) {
            const provinceCities = this.allCities[province].map(city => city.name)
            cityList = [...cityList, ...provinceCities]
          } else {
            console.warn(`省份 ${province} 的数据不是数组:`, this.allCities[province])
          }
        }
        
        if (cityList.length === 0) {
          throw new Error('城市数据格式不正确：没有找到有效的城市数据')
        }
        
        this.allCitiesList = cityList
        this.generateDisplayCities()
        
        console.log('所有城市数量:', this.allCitiesList.length)
        console.log('显示城市数量:', this.displayCities.length)
      } catch (error) {
        console.error('加载城市数据失败:', error)
        this.showErrorMessage('加载城市数据失败，请刷新页面重试')
      }
    },
    generateDisplayCities() {
      // 随机选择最多100个城市用于词云显示
      const maxDisplayCount = 150
      const shuffled = [...this.allCitiesList].sort(() => 0.5 - Math.random())
      this.displayCities = shuffled.slice(0, Math.min(maxDisplayCount, this.allCitiesList.length))
    },
    randomCity() {
      if (this.allCitiesList.length === 0 || this.isDrawing) return
      
      this.isDrawing = true
      
      // 开始词云加速旋转
      this.$refs.wordCloud.startSpeedRotation()
      
      // 3秒后停止旋转并显示结果
      setTimeout(() => {
        this.$refs.wordCloud.stopSpeedRotation()
        
        // 从所有城市中随机选择一个（不限于显示的100个）
        const randomIndex = Math.floor(Math.random() * this.allCitiesList.length)
        const cityName = this.allCitiesList[randomIndex]
        this.selectCity(cityName)
        
        this.isDrawing = false
      }, 3000)
    },
    selectCity(cityName) {
      this.selectedCity = cityName
      
      // 查找城市信息
      for (const province in this.allCities) {
        const cityInfo = this.allCities[province].find(city => city.name === cityName)
        if (cityInfo) {
          this.cityInfo = cityInfo
          break
        }
      }
      
      this.loadCityData(cityName)
      this.showResult()
    },
    async loadCityData(cityName) {
      try {
        const response = await fetch(`/data/${cityName}.json`)
        const data = await response.json()
        this.cityData = data
      } catch (error) {
        console.error(`加载${cityName}数据失败:`, error)
        this.cityData = null
      }
    },
    showResult(cityName) {
      if (cityName) {
        this.selectCity(cityName)
      }
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
    // 在 viewGuide 方法中添加调试信息
    viewGuide() {
      console.log('viewGuide 被调用')
      console.log('selectedCity:', this.selectedCity)
      console.log('cityData:', this.cityData)
      this.showModal = false
      this.showGuide = true
      console.log('showGuide 设置为:', this.showGuide)
    },
    backToHome() {
      this.showGuide = false
    },

    showErrorMessage(message) {
    // 简单的错误提示实现
    alert(message)
    // 或者使用更优雅的提示方式
    // console.error(message)
    // 可以考虑使用 Element UI 的 Message 组件等
  },
    continueDrawing() {
      this.showGuide = false
      // 重新生成显示的城市列表
      this.generateDisplayCities()
      this.randomCity()
    }
  }
}
</script>

<style scoped>
.navbar {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 15px 0;
  text-align: center;
  box-shadow: 0 2px 20px rgba(0,0,0,0.1);
}

.navbar h1 {
  color: #f92727;
  font-size: 24px;
  font-weight: 600;
}

.main-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 40px 20px;
  position: relative;
  z-index: 1;
}

/* 霓虹灯标题 */
.title-container {
  text-align: center;
  margin-bottom: 0px;
}

.title-container h1 {
  font-size: 4.5rem;
  margin-bottom: 20px;
  color: #00ffff;
  text-shadow: 
    0 0 5px #00ffff,
    0 0 10px #00ffff,
    0 0 20px #00ffff,
    0 0 40px #00ffff,
    0 0 80px #00ffff;
  letter-spacing: 3px;
  position: relative;
  animation: cyber-glitch 2s infinite alternate;
  font-weight: 700;
  font-family: 'Courier New', monospace;
  text-transform: uppercase;
}

@keyframes cyber-glitch {
  0% { 
    text-shadow: 
      0 0 5px #00ffff, 
      0 0 10px #00ffff, 
      0 0 20px #00ffff,
      2px 0 0 #ff0080;
  }
  25% {
    text-shadow: 
      0 0 10px #00ffff, 
      0 0 20px #00ffff, 
      0 0 40px #00ffff,
      -2px 0 0 #ff0080;
  }
  50% {
    text-shadow: 
      0 0 15px #00ffff, 
      0 0 30px #00ffff, 
      0 0 60px #00ffff,
      1px 0 0 #ff0080;
  }
  75% {
    text-shadow: 
      0 0 5px #00ffff, 
      0 0 10px #00ffff, 
      0 0 20px #00ffff,
      -1px 0 0 #ff0080;
  }
  100% { 
    text-shadow: 
      0 0 10px #00ffff, 
      0 0 20px #00ffff, 
      0 0 40px #00ffff,
      0px 0 0 #ff0080;
  }
}

.title-container h2 {
  font-size: 1.8rem;
  color: #ff0080;
  text-shadow: 
    0 0 10px rgba(255, 0, 128, 0.8),
    0 0 20px rgba(255, 0, 128, 0.6);
  font-weight: 400;
  letter-spacing: 2px;
  margin-top: 15px;
  font-family: 'Courier New', monospace;
  animation: neon-flicker 3s infinite;
}

@keyframes neon-flicker {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.8; }
  75% { opacity: 0.9; }
}

/* 添加故障效果 */
.title-container h1::before {
  content: attr(data-text);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #ff0080;
  overflow: hidden;
  animation: glitch-1 0.3s infinite linear alternate-reverse;
}

.title-container h1::after {
  content: attr(data-text);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #00ff00;
  overflow: hidden;
  animation: glitch-2 0.3s infinite linear alternate-reverse;
}

@keyframes glitch-1 {
  0% {
    clip: rect(42px, 9999px, 44px, 0);
    transform: skew(0.5deg);
  }
  5% {
    clip: rect(12px, 9999px, 59px, 0);
    transform: skew(0.1deg);
  }
  10% {
    clip: rect(48px, 9999px, 29px, 0);
    transform: skew(0.8deg);
  }
  100% {
    clip: rect(42px, 9999px, 44px, 0);
    transform: skew(0.5deg);
  }
}

@keyframes glitch-2 {
  0% {
    clip: rect(65px, 9999px, 119px, 0);
    transform: skew(0.2deg);
  }
  5% {
    clip: rect(52px, 9999px, 74px, 0);
    transform: skew(0.7deg);
  }
  10% {
    clip: rect(79px, 9999px, 85px, 0);
    transform: skew(0.3deg);
  }
  100% {
    clip: rect(65px, 9999px, 119px, 0);
    transform: skew(0.2deg);
  }
}

/* 赛博朋克3D词云容器 */
/* .word-cloud-container {
  width: 100%;
  height: 500px;
  overflow: hidden;

  background: transparent;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(93, 255, 239, 0.3);
  margin: 50px 0;
  position: relative;
  max-width: 1200px;
} */

/* 霓虹按钮 */
.lottery-button {
  display: block;
  margin: 20px auto;
  padding: 18px 60px;
  font-size: 1.5rem;
  font-weight: 700;
  background: rgba(255, 0, 93, 0.15);
  color: #ff005d;
  border: 2px solid #ff005d;
  border-radius: 50px;
  text-transform: uppercase;
  letter-spacing: 2px;
  cursor: pointer;
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 
    0 0 15px rgba(255, 0, 93, 0.3),
    inset 0 0 10px rgba(255, 0, 93, 0.1);
}

.lottery-button:hover {
  background: rgba(255, 0, 93, 0.3);
  transform: translateY(-5px);
  box-shadow: 
    0 5px 25px rgba(255, 0, 93, 0.6),
    inset 0 0 15px rgba(255, 0, 93, 0.3);
  text-shadow: 0 0 8px rgba(255, 0, 93, 0.8);
}

.lottery-button:active {
  transform: translateY(0);
  box-shadow: 
    0 0 20px rgba(255, 0, 93, 0.8),
    inset 0 0 20px rgba(255, 0, 93, 0.4);
}

.lottery-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.lottery-button::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -60%;
  width: 30px;
  height: 200%;
  background: rgba(255, 255, 255, 0.4);
  transform: rotate(30deg);
  transition: all 0.6s;
}

.lottery-button:hover::before {
  left: 120%;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .title-container h1 {
    font-size: 3rem;
  }
  
  .title-container h2 {
    font-size: 1.3rem;
  }
  
  .word-cloud-container {
    height: 350px;
    margin: 30px 0;
  }
  
  .lottery-button {
    padding: 15px 40px;
    font-size: 1.3rem;
    margin-top: 250px;
  }
}

@media (max-width: 480px) {
  .title-container h1 {
    font-size: 2.3rem;
  }
  
  .title-container h2 {
    font-size: 1.1rem;
  }
  
  .word-cloud-container {
    height: 300px;
  }
}
</style>